export default {
	async _refreshCsrf() {
		try { 
			let csrf = await this.$get('/json/csrf');
			document.head.querySelector('meta[name="csrf-token"]').content = csrf.token;
			this.$http.defaults.headers.common['X-CSRF-TOKEN'] = csrf.token;
		} catch(e) {
			console.log(e);
		}
	},
	async get(endpoint, data, headers) {
		return this._request('get', endpoint, data, headers);
	},
	async post(endpoint, data, headers) {
		return this._request('post', endpoint, data, headers);
	},
	async put(endpoint, data, headers) {
		return this._request('put', endpoint, data, headers);
	},
	async patch(endpoint, data, headers) {
		return this._request('patch', endpoint, data, headers);
	},
	async delete(endpoint, data, headers) {
		return this._request('delete', endpoint, data);
	},
	async upload(endpoint, data, method, headers) {
		if(!method) {
			method = 'post';
		}
		if(!headers) {
			headers = {};
		}
		headers['Content-Type'] = 'multipart/form-data';
		let fd = this._toFormData(data);
		return this._request(method, endpoint, fd, headers);
	},
	async _request(method, endpoint, params, headers) {
		let formattedHeaders = (headers)?headers:{};
		let formattedParams = (method === 'get')?{params: params}:params;
		try {
			if(typeof(window) === 'undefined'){
				endpoint = process.env.APP_URL + endpoint;
			}
			let response = await this.$http[method](endpoint, formattedParams, formattedHeaders);
			if(response.data.message) {
				this.$setMessages([response.data.message]);
			}
			return response.data;
		} catch(e) {
			if(!e.response) {
				throw e;
			}
			let error = new Error();
			error.code = e.response.status;
			if(e.response.status === 419){
				await this._refreshCsrf();
				return await this._request(method, endpoint, params, headers);
			}
			if(e.response.data && e.response.data.message && [422, 500, 404].indexOf(e.response.status) === -1) {
				this.$setErrors([e.response.data.message]);
			}
			if(e.response.status === 401) {
				this.$store.state.user = null;
				await this.$navigate('/');
			}
			if(e.response.status === 403) {
				await this.$navigate(e.response.data.redirect || '/');
			}
			if(e.response.status === 422 && e.response.data.errors) {
				error.data = e.response.data.errors;
			} 
			/*if(e.response.status === 500) {
				console.log('show error screen');
			}*/
			throw error;
			
		}
	},
	_toFormData(obj) {
		const fd = new FormData();
        this._buildFormData(fd, obj);
        return fd;
	},
	_buildFormData(fd, data, parent) {
		let self = this;
		if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            Object.keys(data).forEach((key) => {
                self._buildFormData(fd, data[key], (parent)?`${parent}[${key}]`:key);
            });
        } else {
            const value = (data == null)?'':data;
            fd.append(parent, value);
        }
	}
}